import ZModal from './Modal.vue'
export default ZModal
